
export class AuthYuipotaAuthResponse {
  yuipotaRedirectUrl?: string

  constructor(yuipotaRedirectUrl?:string) {
    this.yuipotaRedirectUrl = yuipotaRedirectUrl
  }
}
